import React, {useMemo, useCallback, useState, useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import { styled } from '@mui/material/styles';
import { FormControl } from '@mui/material';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: '20px',
  borderColor: '#929292',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  minHeight: '130px',
  margin: '20px'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#5664d2'
};

const rejectStyle = {
  borderColor: '#eb7e83'
};

const UploadAction = styled('div')(({ theme }) => ({
  textAlign: 'center',
  '& button': {
    margin: '12px !important',
    background: '#fff'
  }
}));

const StyledDropzone = ({submitFile, ...props}) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [uploaded, setUploaded] = useState(false)
  const [reportType, setReportType] = useState('')
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files
    setUploaded(acceptedFiles.length)
  }, [])
  const removeFile = ()=>{
    acceptedFileItems.splice(0,1)
    setUploaded(false)
  }
  const handleClose = () => {
    setOpenDialog(false)
    setReportType('')
  }
  // console.log(props.uplaodStatus)
  useEffect(() => {
    if(props.uplaodStatus) {
      setUploaded(false)
    }
  }, [props])
  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    fileRejections,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({onDrop, maxFiles: 1, accept: 'text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

  const acceptedFileItems = acceptedFiles.map((file,idx) => (
    <div key={idx} style={{textAlign: 'center'}}>
      <img
        alt="Upload Excel"
        src="/static/images/xlsx.svg"
        style={{
          display: 'inline-block',
          height: 60
        }}
      />
      <p key={file.path} style={{
        color: 'black',
        marginTop: '5px'
      }}>{file.path} - {file.size} bytes</p>
    </div>
  ));
  
  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  return (
    <>
      <section className="container">
        { !uploaded ? <div {...getRootProps({style})}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop some files here, or click to select files</p>
          <em>(Only *.xlsx files will be accepted)</em>
        </div> : <div {...getRootProps({style})}>{acceptedFileItems}</div> }
      </section>
      { uploaded ? <UploadAction>
          <Button
            variant="contained"
            color="background"
            startIcon={<DeleteIcon />}
            onClick={removeFile}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="background"
            endIcon={<SendIcon/>}
            onClick={()=> setOpenDialog(true)}
          >
            Submit
          </Button>
      </UploadAction> : null }
      <Dialog
        maxWidth={'xs'}
        open={openDialog}
        onClose={handleClose}
      >
        <DialogTitle id="dialog-title">Report Type</DialogTitle>
        <DialogContent sx={{minWidth: '400px'}}>
          {/* <DialogContentText>
            Choose report type
          </DialogContentText> */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                autoFocus
                variant="outlined"
                value={reportType}
                placeholder="Vaccination"
                onChange={(e) => setReportType(e.target.value)}
              >
              </TextField>
            </FormControl>
            </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDialog(false); submitFile(acceptedFiles.slice(0,1), reportType); }} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
  </>
  );
}

StyledDropzone.propTypes = {
  submitFile: PropTypes.func.isRequired,
  uplaodStatus: PropTypes.bool
}

export default StyledDropzone
